import { ReactNode, useEffect, useState } from 'react';
import { classNames } from '../../utils';
import * as Slider from '@radix-ui/react-slider';
import { isNull } from 'lodash';
import { clamp } from '@radix-ui/number';

export function convertValueToPercentage(
  value: number,
  min: number,
  max: number
) {
  const maxSteps = max - min;
  const percentPerStep = 100 / maxSteps;
  const percentage = percentPerStep * (value - min);
  return clamp(percentage, [0, 100]);
}

export function ResponsiveCostSlider({
  className,
  value,
  min,
  max,
  step,
  onChange,
  valueDisplay,
  sliderValueWrapperClassName,
  valueClassName,
  bottomText,
  bottomTextClassName,
  sliderClassName,
  disabled,
  marker,
}: {
  disabled?: boolean;
  className?: string;
  value: number;
  max: number;
  step: number;
  min: number;
  onChange?: (value: number) => void;
  valueDisplay?: (
    value: number | null | undefined,
    isDragging?: boolean
  ) => ReactNode;
  bottomText?: (
    value: number | null | undefined,
    isDragging?: boolean
  ) => ReactNode;
  bottomTextClassName?: string;
  sliderValueWrapperClassName?: string;
  valueClassName?: string;
  sliderClassName?: string;
  marker?: number;
}) {
  const [currentDraggingValue, setCurrentDraggingValue] =
    useState<number>(value);
  const [isDragging, setIsDragging] = useState(false);

  // console.log('value =======>', {
  //   currentDraggingValue,
  //   value,
  //   max,
  //   min,
  //   step,
  // });

  return (
    <div className={className}>
      <div
        className={classNames(
          'flex items-center justify-between gap-4',
          sliderValueWrapperClassName
        )}
      >
        {valueDisplay ? (
          <div className={valueClassName}>
            {valueDisplay?.(currentDraggingValue, isDragging)}
          </div>
        ) : null}
        <Slider.Root
          disabled={disabled}
          className={classNames(
            'relative flex h-5 w-full flex-[3] touch-none select-none items-center',
            sliderClassName
          )}
          defaultValue={[value]}
          value={[isDragging ? currentDraggingValue : value]}
          min={min}
          max={max}
          step={step}
          //@ts-ignore
          onValueChange={(e) => {
            // console.log('on value change', e[0])
            setCurrentDraggingValue(e[0]);
          }}
          onValueCommit={() => {
            // console.log('on value commit', e[0])
            // onChange?.(e[0]);
          }}
          onPointerDown={() => {
            setIsDragging(true);
            setCurrentDraggingValue(value);
          }}
          onPointerUp={() => {
            onChange?.(currentDraggingValue as number);
            setIsDragging(false);
          }}
        >
          <Slider.Track className="bg-hardwood-300 relative h-[2px] grow rounded-[2px]">
            <Slider.Range className="bg-hardwood-300 absolute h-full rounded-[2px]" />
          </Slider.Track>
          {typeof marker !== 'undefined' ? (
            <div
              className=" bg-hardwood-400 border-hardwood-30 absolute h-[8px] w-[8px] rounded-full border-[2px]"
              style={{
                left: `calc(${convertValueToPercentage(
                  marker,
                  min,
                  max
                )}% - ${3}px)`,
              }}
            ></div>
          ) : null}
          <Slider.Thumb
            className={classNames(
              'hover:bg-violet3 focus:shadow-blackA8 bg-morton-100 border-morton-600 block h-[16px] w-[16px] rounded-[16px] border-[2px] focus:outline-none',
              isDragging ? 'cursor-grabbing' : 'cursor-grab'
            )}
          />
        </Slider.Root>
      </div>
      {bottomText ? (
        <div
          className={classNames(
            'typo-body-small text-hardwood-600 mt-4 text-center text-[12px] normal-nums',
            bottomTextClassName
          )}
        >
          {bottomText?.(currentDraggingValue, isDragging)}
        </div>
      ) : null}
    </div>
  );
}
